import PaymentMethods from "../../../Components/User/Profile/PaymentMethods/PaymentMethods";
import PaymentHistory from "../../../Components/User/Profile/PaymentHistory/PaymentHistory";
import MyProfile from "../../../Components/User/Profile/MyProfile/MyProfile";
import { getProfile } from "../../../Redux/Profile/ProfileActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import styles from "./Profile.module.scss";

function Profile() {
  const [activeTab, setActiveTab] = useState("myProfile");
  const dispatch = useDispatch<AppDispatch>();
  const { profileLoading } = useSelector((state: RootState) => state.profile);

  const tabs = [
    {
      label: "My Profile",
      value: "myProfile",
    },
    {
      label: "Payment Methods",
      value: "paymentMethods",
    },
    {
      label: "Payment History",
      value: "paymentHistory",
    },
  ];
  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
              onClick={() => setActiveTab(tab.value)}
            >
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab === "myProfile" && <MyProfile />}
          {activeTab === "paymentMethods" && <PaymentMethods />}
          {activeTab === "paymentHistory" && <PaymentHistory />}
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    dispatch(getProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (profileLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Profile</p>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.tabsContainer}>{tabsRenderer()}</div>
      </div>
    </div>
  );
}

export default Profile;
